import type { ODSIconName } from '@telekom-ods/react-icons';
import {
  ODSButton,
  type ODSButtonButtonType,
  type ODSButtonSize,
  type ODSButtonVariant,
} from '@telekom-ods/react-ui-kit';

interface ButtonProps {
  type?: 'submit' | 'reset' | 'button' | undefined;
  buttonType?: ODSButtonButtonType;
  label?: string;
  size?: ODSButtonSize;
  variant?: ODSButtonVariant;
  disabled?: boolean;
  href?: string;
  download?: string | null;
  onClick?: (() => void) | null;
  icon?: ODSIconName;
  leftIcon?: boolean;
  rightIcon?: boolean;
  name?: string;
}

const Button: React.FC<ButtonProps> = ({
  type = 'button',
  buttonType = 'standard',
  label = 'Submit',
  size = 'small',
  variant = 'primary',
  disabled = false,
  href,
  download = null,
  onClick = null,
  icon,
  leftIcon = false,
  rightIcon = false,
  name,
  ...otherProps
}) => {
  const hrefValue = download ? '' : (href ?? '');

  const odsButton = (
    <ODSButton
      type={type}
      variant={variant}
      label={label}
      buttonType={buttonType}
      size={size}
      disabled={disabled}
      onClick={onClick ?? undefined}
      {...(icon && { buttonIcon: icon })}
      leftIcon={leftIcon}
      rightIcon={rightIcon}
      href={hrefValue}
      name={name}
      {...otherProps}
    >
      {label}
    </ODSButton>
  );

  // If download is provided, wrap the button in an anchor tag
  // to enable downloading functionality
  if (download) {
    return (
      <a
        href={href ?? undefined}
        download={download}
        style={{ textDecoration: 'none' }}
      >
        {odsButton}
      </a>
    );
  }

  return odsButton;
};

export default Button;
